import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { RestService } from "@stdoutsrl/design-kit";
import { LoaderService, Message } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-custom-modal-store-date",
  templateUrl: "modal-store-date.component.html",
  styles: [],
  standalone: false,
})
export class ModalStoreDateComponent implements OnInit {
  constructor(
    private host: ElementRef<HTMLElement>,
    private rest: RestService,
    private message: Message,
    private loader: LoaderService
  ) { }

  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;
  highRange: any[] = []
  showSelectTime = false
  isChanging = false
  myDay = {
    day: 0,
    timeStart: "00:00:00",
    timeEnd: "00:00:00",
    highRange: ""
  }

  ngOnInit(): void {
    if (this.fatherElement) {
      this.myDay = {
        day: this.fatherElement.day,
        timeStart: this.fatherElement.timeStart,
        timeEnd: this.fatherElement.timeEnd,
        highRange: this.fatherElement.highRange
      }
      this.highRange = JSON.parse(this.fatherElement.highRange)
    }
  }

  addHighRange() {
    this.highRange.push({
      timeStart: "00:00:00",
      timeEnd: "00:00:00",
    })
  }

  removeHighRange(index: number) {
    this.highRange.splice(index, 1)
    this.isChanging = !this.isChanging
  }

  changeDay(event: any) {
    this.myDay.day = event.value
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }

  createTimetable() {
    this.myDay.highRange = JSON.stringify(this.highRange)
    this.loader.on();
    let myFunction = this.fatherElement ? this.rest.patch(`/store/${this.fatherContaierRef.myData.id}/timetables/${this.fatherElement.id}`, this.myDay) : this.rest.post(`/store/${this.fatherContaierRef.myData.id}/timetables`, this.myDay)
    myFunction.subscribe({
      next: (value) => {
        this.loader.off();
        this.message.showMessage("Giorno creato con successo", "success");
        this.fatherContaierRef.getSubTables();
        this.autoDestory();
      },
      error: (value) => {
        this.loader.off();
        this.message.showMessage(
          "Errore nella creazione",
          "error"
        );
        this.autoDestory();
      },
    });
  }
}
